import { GridLegacy as Grid, Box, Stack, CircularProgress } from '@mui/material';
import { AdminOrgDataPanel } from '@old/features/administrator/section-org-data/org-data-panel';
import { AdminCustomizationBar } from '@old/features/administrator/section-customization/customization-bar';
import { AdminCompanyList } from '@old/features/administrator/list-company/company-list';
import { AdminCountrysideList } from '@old/features/administrator/list-countryside/countryside-list';
import { AdminUserList } from '@old/features/administrator/list-user/user-list';

import { useService } from '@old/hooks/use-service';
import { useGlobalStore } from '@old/global-store/use-store';
import { useLocation } from 'react-router';
import i18n from '../../libs/language';
import { useState } from 'react';
import { useEffectOnUpdate } from '@old/hooks/core';
import { organizationDataService } from '@old/services/domain/base/organization/organization-data';
import { WarantsPanel } from '@old/features/administrator/warrants/warants-panel';

export const AdministratorPage = () => {
  const { userOrganizationId } = useGlobalStore();
  const [inspectionModalToggle, setInspectionModalToggle] = useState(false);
  const [actionInCompany, setActionInCompany] = useState(false);
  const [actionInCountryside, setActionInCountryside] = useState(false);
  const [actionInUser, setActionInUser] = useState(false);
  const location = useLocation();

  const {
    trigger, //
    summary: orgData, //
  } = useService(organizationDataService, { fetchOnMount: [{ query: userOrganizationId! }] });
  const reFetchOrgData = () => trigger({ query: userOrganizationId! });

  useEffectOnUpdate(() => {
    if (inspectionModalToggle) {
      setInspectionModalToggle(false);
    }
  }, [inspectionModalToggle]);

  return (
    <Box
      style={{
        backgroundColor: '#f3f2f7',
        width: '98%',
        margin: '0 auto',
        padding: 1,
      }}
    >
      <Stack>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', gap: 3, justifyContent: 'space-between', alignItems: 'center', my: 2 }}
        >
          <Box sx={{ fontWeight: '600', fontSize: '24px' }}>{i18n.t('app.administrator.title')}</Box>
          {orgData ? (
            <Box style={{ textAlign: 'center' }}>
              <span style={{ fontWeight: '600' }}>{i18n.t('app.organization')}: </span>
              {orgData.name}
            </Box>
          ) : (
            <Stack style={{ width: '15%' }} justifyContent="center" alignItems="center">
              <CircularProgress size={16} />
            </Stack>
          )}
        </Grid>
        <AdminOrgDataPanel orgData={orgData} onSuccessTrigger={reFetchOrgData} updateAdminData={trigger} />
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr 1fr' },
            gridTemplateRows: { xs: 'auto', md: 'auto auto 1fr' },
            gap: 2,
            overflowX: { xs: 'auto', md: 'unset' },
          }}
        >
          <Box
            sx={{
              gridColumn: { xs: '1', md: '1 / 3' },
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minWidth: { xs: '300px', md: 'unset' },
            }}
          >
            <WarantsPanel />
          </Box>

          <Box
            sx={{
              gridColumn: { xs: '1', md: '3 / 5' },
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minWidth: { xs: '300px', md: 'unset' },
            }}
          >
            <AdminCustomizationBar
              state={location.state}
              onRefreshAlborList={setInspectionModalToggle}
              setActionInUser={setActionInUser}
            />
          </Box>

          <Box
            sx={{
              gridColumn: { xs: '1', md: '1 / 3' },
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minWidth: { xs: '300px', md: 'unset' },
            }}
          >
            <AdminCompanyList
              setActionInCompany={setActionInCompany}
              integrationModalClosed={inspectionModalToggle}
            />
          </Box>

          <Box
            sx={{
              gridColumn: { xs: '1', md: '3 / 5' },
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minWidth: { xs: '300px', md: 'unset' },
            }}
          >
            <AdminUserList
              actionInCompany={actionInCompany}
              actionInCountryside={actionInCountryside}
              setActionInCountryside={setActionInCountryside}
              setActionInUser={setActionInUser}
            />
          </Box>

          <Box
            sx={{
              gridColumn: { xs: '1', md: '1 / 5' },
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minWidth: { xs: '300px', md: 'unset' },
            }}
          >
            <AdminCountrysideList
              integrationModalClosed={inspectionModalToggle}
              actionInCompany={actionInCompany}
              actionInUser={actionInUser}
              setActionInCompany={setActionInCompany}
              setActionInCountryside={setActionInCountryside}
              setActionInUser={setActionInUser}
            />
          </Box>
        </Grid>
      </Stack>
    </Box>
  );
};
